import { useEffect, useState } from "react";
import { db } from "../firebase";
import {
  collection,
  getDocs,
} from "firebase/firestore";
import { useNavigate } from "react-router-dom";

function CsScreen() {
  const [data, setData] = useState([]);
  const [tab, setTab] = useState("upcoming");

  const navigate = useNavigate();

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    const snap = await getDocs(collection(db, "cs_tournaments"));

    const list = snap.docs.map((d) => ({
      id: d.id,
      ...d.data(),
    }));

    setData(list);
  };
  const now = new Date();

  const filtered = data.filter((t) => {
    const time = t.time?.seconds
      ? new Date(t.time.seconds * 1000)
      : new Date();

    return tab === "upcoming" ? time >= now : time < now;
  });

  return (
    <div style={{ color: "white", padding: 20 }}>
      <h1>🎮 CS 1v1 / 2v2 Tournaments</h1>

      {/* 🔥 CREATE BUTTON */}
      <button onClick={() => navigate("/create-cs")} style={btn}>
        ➕ Create Tournament
      </button>

      {/* 🔥 TABS */}
      <div style={tabs}>
        <button
          style={tabBtn(tab === "upcoming")}
          onClick={() => setTab("upcoming")}
        >
          Upcoming
        </button>

        <button
          style={tabBtn(tab === "completed")}
          onClick={() => setTab("completed")}
        >
          Completed
        </button>
      </div>

      {/* 🔥 LIST */}
      {filtered.map((t) => (
        <div key={t.id} style={card}>
          <h3>{t.title}</h3>

          <p>📍 {t.map}</p>
          <p>💰 Prize: ₹{t.prizePool}</p>
          <p>💸 Entry Fee: ₹{t.entryFee || 0}</p>
          <p>⚔ Per Kill: ₹{t.perKill || 0}</p>

          <p>
            ⏰{" "}
            {t.time?.seconds
              ? new Date(t.time.seconds * 1000).toLocaleString()
              : "No Time"}
          </p>

          {/* 🔥 ACTIONS */}
          <div style={{ marginTop: 10, display: "flex", gap: 10 }}>

  {/* ✏️ EDIT */}
  <button
    style={smallBtn}
    onClick={() =>
      navigate("/edit", {
        state: {
          id: t.id,
          data: t,
          collectionName: "cs_tournaments",
        },
      })
    }
  >
    ✏️ Edit
  </button>

  {/* ❌ DELETE */}
  <button
  style={smallBtn}
  onClick={() =>
    navigate("/delete", {
      state: {
        id: t.id,
        data: t,
        collectionName: "cs_tournaments",
      },
    })
  }
>
  ❌ Delete
</button>
<button
  onClick={() =>
    navigate("/add-room", {
      state: {
        tournamentId: t.id,
        collectionType: "cs_tournaments", // 🔥 change according to screen
      },
    })
  }
>
  🏠 Room
</button>
<button
  disabled={t.winnerDeclared}
  onClick={async () => {
    // 🔥 participants fetch
    const snap = await getDocs(
      collection(db, "cs_tournaments", t.id, "participants") // 👈 change per screen
    );

    const participantsData = snap.docs.map((d) => d.data());

    navigate("/decide-winner", {
      state: {
        tournamentId: t.id,
        participants: participantsData,
        tournamentData: t,
        collectionType: "cs_tournaments", // 👈 IMPORTANT change per type
      },
    });
  }}
  style={{
    padding: "6px 10px",
    borderRadius: 6,
    border: "none",
    cursor: t.winnerDeclared ? "not-allowed" : "pointer",
    background: t.winnerDeclared ? "#16A34A" : "#2563EB",
    color: "#fff",
  }}
>
  {t.winnerDeclared ? "✅ Winner Done" : "🏆 Decide"}
</button>
</div>
        </div>
      ))}
    </div>
  );
}

/* 🔥 STYLES */

const btn = {
  background: "green",
  color: "white",
  padding: 10,
  border: "none",
  borderRadius: 8,
  marginBottom: 20,
  cursor: "pointer",
};

const tabs = {
  display: "flex",
  gap: 10,
  marginBottom: 20,
};

const tabBtn = (active) => ({
  padding: "8px 14px",
  borderRadius: 20,
  border: "none",
  cursor: "pointer",
  background: active ? "#2563EB" : "#1E2235",
  color: "#fff",
});

const card = {
  background: "#1E2235",
  padding: 15,
  borderRadius: 10,
  marginBottom: 12,
};

const smallBtn = {
  padding: "6px 10px",
  border: "none",
  borderRadius: 6,
  cursor: "pointer",
};

export default CsScreen;